import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setBuyPlans } from "../../store/slices/generics.slice";

function ManageAccountTabs() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);

  var pathname = window.location.pathname;

  var tabs = [
    {
      name: "PERSONAL_INFO",
      link: "/manage-account",
      class: pathname === "/manage-account" ? "tab-list-item tab-list-active" : "tab-list-item",
    },
  ];

  if (user?.role === "student" && !user?.firstAccess) {
    tabs.push({
      name: "PLANS",
      link: "/manage-account/plan",
      class: pathname === "/manage-account/plan" ? "tab-list-item tab-list-active" : "tab-list-item",
    });
    tabs.push({
      name: "LEVEL_SCORE",
      link: "/manage-account/levelscore",
      class: pathname === "/manage-account/levelscore" ? "tab-list-item tab-list-active" : "tab-list-item",
    });
    tabs.push({
      name: "NOTIFICATION",
      link: "/manage-account/notification",
      class: pathname === "/manage-account/notification" ? "tab-list-item tab-list-active" : "tab-list-item",
    });
  }

  return (
    <ol className="tab-list">
      <div className="tabsContent">
        {tabs.map((tab, index) => {
          return (
            <Link
              key={index}
              to={{ pathname: tab.link }}
              onClick={() => {
                if (tab.name !== "PLANS") dispatch(setBuyPlans([]));
              }}
            >
              <li className={tab.class}>{t(tab.name)}</li>
            </Link>
          );
        })}
      </div>
    </ol>
  );
}

export default ManageAccountTabs;
